<template>
  <div>
    <p class="titleModal">
      {{ $t(`technicalFile.boiler.step2.title`) }}
    </p>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="8"
      >
        <VTextField
          v-model="data.dailyOperationTime.value"
          :label="$t('technicalFile.boiler.step2.dailyOperationTime')"
          formatNumber
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="noYPadding"
      >
        <VSelect
          v-model="data.dailyOperationTime.units"
          :label="$t('technicalFile.boiler.step2.units')"
          :items="displayedUnits('genericTime', ['hr'])"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="genericTime"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="8"
      >
        <VTextField
          v-model="data.yearlyOperationTime.value"
          :label="$t('technicalFile.boiler.step2.yearlyOperationTime')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="noYPadding"
      >
        <VSelect
          v-model="data.yearlyOperationTime.units"
          :label="$t('technicalFile.boiler.step2.units')"
          :items="displayedUnits('genericTime', ['day', 'month'])"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="volume"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'NetworkIdentification',
    components: {
        VTextField,
    },
    props: {
        operation: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                dailyOperationTime: {},
                yearlyOperationTime: {},
            },
        };
    },
    computed: {
        ...mapGetters([
            'units',
        ]),
    },
    watch: {
        operation: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.operation) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { operation: this.data });
        },
        displayedUnits(type, filter = []) {
            if (!this.units || !this.units[type]) {
                return [];
            }

            return filter.length === 0 ? this.units[type] : this.units[type].filter(unit => filter.includes(unit.name));
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
.noYPadding {
  padding-bottom: 0;
  padding-top: 0;
}
@media screen and (max-width: 600px) {
  .xPadding{
    padding: 0;
  }
}
</style>
